import { merge } from 'es-toolkit/compat'

export interface TimeslotSettings {
  hoverBackground?: string
  activeColor?: string
  activeBackground?: string
  showPrice?: boolean
}

export interface PrepaymentRefundNoticeSettings {
  show?: boolean
  hours?: number
}

export interface CompanySettings {
  showTimezone?: boolean
  showServiceDuration?: boolean
  showMinServicePrice?: boolean
  showMinBookingPrice?: boolean
  showMinTargetPrice?: boolean
  showCapacity?: boolean
  prepaymentRefundNotice?: PrepaymentRefundNoticeSettings
  timeslot: TimeslotSettings
}

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>
type CustomCompanySettings = Optional<CompanySettings, 'timeslot'>

export const defaultCompanySettings: CompanySettings = {
  showTimezone: true,
  showServiceDuration: true,
  showMinServicePrice: true,
  showMinBookingPrice: true,
  showMinTargetPrice: true,
  showCapacity: true,
  prepaymentRefundNotice: {
    show: false,
    hours: 72,
  },
  timeslot: {
    hoverBackground: 'unset',
    activeColor: 'var(--cue-content-primary-on-soft)',
    activeBackground: 'var(--cue-bg-primary-soft-dark)',
    showPrice: true,
  },
} satisfies CompanySettings

const vorontsovskieBaniSettings = {
  showTimezone: false,
  showServiceDuration: false,
  showCapacity: false,
  timeslot: {
    hoverBackground: 'var(--cue-bg-primary-soft-hover)',
    activeColor: 'var(--cue-bg-primary-on-default)',
    activeBackground: 'var(--cue-bg-primary-default)',
  },
} satisfies CustomCompanySettings

const mechtaSettings = {
  timeslot: {
    showPrice: false,
  },
} satisfies CustomCompanySettings

const mafiaVipSettings = {
  showMinServicePrice: false,
  showMinTargetPrice: false,
} satisfies CustomCompanySettings

const studio1884Settings = {
  timeslot: {
    showPrice: false,
  },
} satisfies CustomCompanySettings

const mokkaSettings = {
  timeslot: {
    showPrice: false,
  },
} satisfies CustomCompanySettings

const _23studioSettings = {
  showMinServicePrice: false,
  showMinTargetPrice: false,
  timeslot: {
    showPrice: false,
  },
} satisfies CustomCompanySettings

const prostranstvoSettings = {
  timeslot: {
    showPrice: false,
  },
} satisfies CustomCompanySettings

const pyatnizaStudioSettings = {
  timeslot: {
    showPrice: false,
  },
}

const frendiSettings = {
  timeslot: {
    showPrice: false,
  },
}

const fotostudioTeploSettings = {
  timeslot: {
    showPrice: false,
  },
}

const psikhologViktoriyaGrigoryevaSettings = {
  showMinServicePrice: false,
  showMinTargetPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const skypointSettings = {
  showMinServicePrice: false,
  showMinTargetPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const pekloSettings = {
  showMinServicePrice: false,
  showMinBookingPrice: false,
  showMinTargetPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const fabrikaStudio = {
  showMinServicePrice: false,
  showMinTargetPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const hitomaniaSettings = {
  showMinBookingPrice: false,
  prepaymentRefundNotice: {
    show: true,
    hours: 72,
  },
}

const vipmafiaSettings = {
  timeslot: {
    showPrice: false,
  },
}

const naedineSettings = {
  showMinServicePrice: false,
  showMinBookingPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const grandArenaSettings = {
  showMinServicePrice: false,
  showMinBookingPrice: false,
  timeslot: {
    showPrice: false,
  },
}

const besedkiSettings = {
  showMinServicePrice: false,
  showMinBookingPrice: false,
  timeslot: {
    showPrice: false,
  },
}

function getCustomCompanySettings(clientId?: number) {
  switch (clientId) {
    case 1761:
    case 4020:
      return vorontsovskieBaniSettings
    case 782:
      return mechtaSettings
    case 2040:
      return mafiaVipSettings
    case 1336:
      return studio1884Settings
    case 2384:
      return mokkaSettings
    case 2432:
      return _23studioSettings
    case 2616:
      return prostranstvoSettings
    case 2591:
      return pyatnizaStudioSettings
    case 2664:
      return frendiSettings
    case 2862:
      return fotostudioTeploSettings
    case 2913:
      return psikhologViktoriyaGrigoryevaSettings
    case 2564:
      return skypointSettings
    case 3533:
      return pekloSettings
    case 1589:
      return fabrikaStudio
    case 2942:
    case 2945:
      return hitomaniaSettings
    case 2405:
      return vipmafiaSettings
    case 3903:
      return naedineSettings
    case 3799:
      return grandArenaSettings
    case 3800:
      return besedkiSettings
    default:
      return {}
  }
}

export function getCompanySettings(clientId?: number): CompanySettings {
  const custom = getCustomCompanySettings(clientId)
  return merge(defaultCompanySettings, custom)
}
